export default __webpack_public_path__ + "static/media/radius.1347310d.png";